<div class="text-center">
  <a class="btn btn-primary" routerLink="manage">Manage Advertisement Banner</a>
</div>

<h4 class="mb-3">Current Advertisement Banner </h4>
<app-image-slider ></app-image-slider>

